const getQueryParameterByName = require('../helpers/GetQueryParam');

const offerIdLookupHackJob = {
  "1596355": "7C49AFBAD4F14572A36EA49771901104",
  "1596357": "1B5C506943F44E129226644B6C1310E6",
  "1596363": "0C8897CA313B4FF68F9ECC6E510499EE",
  "1596364": "E8C18FEAA00D490C94A0C6DCD0E285D4",
  "1596366": "78828D3C27274E1DBD476CA638C2AA17",
  "1596368": "930558BA5F0943F890095216A62BDE6D",
  "1596370": "BCDF00509D404A9EBC53713F418D203C",
  "1596372": "1D53C798797148479725EDA61E20CAA2",
  "1596373": "6A265FDC9A5E4809882C7DB9A99BDE89",
  "1596375": "1915AEB8F82F47E2BB74DAE4B1F08616",
  "1717348": "A1FE837E8E824B3FAD798375676AD2C6",
  "1717358": "39CB01F39BA54FAEBBADC136355D1A57",
  "1717361": "054284808246404EAC55FBB415D54EC3",
  "1717363": "818B887D6BDF446E95C63165A137911C",
  "1717375": "E64B10575DED4534AFD99CA10660D78E",
  "1819390": "13DF1E2AA9D546E59E40B2132B83FD54",
  "1946008": "40977637D0AD4EA9AECDEDB6577D819D",
  "2198013": "4BEF8121C48C49EEA0D3D5354C536006",
  "2385540": "96C509867D1041D5983B9F5CF6E52759",
  "2416170": "9A459CF7912F45A19E30F825E0B08410",
  "2416174": "E6E3BF55EECB414792DD0851B4D5A0BF",
  "3335034": "65D45B13C48A4301984279C8A2F8DE01",
  "3335039": "082E56B0982641E2B8BA6CC5055C244B",
  "4122622": "277CB47D4A7B467AB903B0F1A784133C",
  "4122636": "87AEE53C168F48CDB6C946D32CF92AF4",
  "4768009": "9A60A814D6254BBDACF4660A8CE462AB",
  "5141847": "2BA8AF36AA7440A8AD022377938A120D",
  "5141851": "96A94C034A62420EAE5314B45FD12805",
  "5303721": "7BEE30286494442B9360D6CB14B44A3B",
  "5303725": "B36F2E1B76084FEDBF19ACB9C4DB2CE1",
  "5650658": "5E30AA754437432381B670EC8FB26003",
  "5823671": "666275F4B21A4B819179090E95394A67",
  "6562485": "B653F261345442BB81F27CC2F95A2E98",
  "7810870": "4EBEAC9C3ED44F61AA36C03D2619FAAC",
  "7933882": "B26FF9B97BF540FCBFF158F846DAE35F",
  "8001484": "8776F9D8C4414C8B9A1160A71D80E7B3",
  "8001486": "7B1ECB0DDF4D4C50A0AAB0052619C6D5",
  "8305096": "4B3B87C9DEF84E5D82849046137F9FAF",
  "9243379": "FA8CF8875B3647F2B6EF71DBC0F4E7A0",
  "9243380": "150252F516994CAEB7318A9E36E82BC5",
  "9243381": "E9CD9444B84141668A96CBF56A3D23C1",
  "9243385": "CE96DEFB7722449C9B2D6CA9B1BDAFE6",
  "10749498": "668C9174A7514AB2B925332C438FA5C0",
  "10749504": "7F2EEAC0414B4BE0A3AA3F3FD4EE8F27",
  "10749508": "B9846A3D62124DF38108F36A134D588C",
  "10749536": "20AF4D92A2F9473FA3A792A0D6DC6FAE",
  "10749542": "62BBB5169F484A6A9E3A608638D63EF0",
  "10750057": "DD1F56C7D4374A608DA74846F8C5BF54",
  "10750066": "52385A4D84124A1DACDC75920E2F2C26",
  "10750070": "BD010ECA5D9549A0BD1E2750EF0007C3",
  "10995027": "6CD7E496149A48759653BAB56194DC98",
  "10998244": "E12AD1DB702D4680BF6DB71F419AFAD5",
  "11973263": "1685EA7489C14008931342D92A9BC721",
  "11973268": "5FF912D8F87D4CDE9430A7B3AD2C9250",
  "11973271": "84144C05279D4AD48BB08598CB72E13F",
  "12172694": "ADE1BF1E768644B1AE77E54656638E0B",
  "12172704": "B94F384BAEEA4132BCE2417DE64D144D",
  "12172708": "209251A0301643F786D7C0F2BA95CD85",
  "12172712": "CB208AA96C9D4273B3FB54BACC590933",
  "12177785": "379C76CC259143D7A794F7B61374FC53",
  "13909270": "E7E780302C3745E19AAA9AE2201B3650",
  "13909276": "985C49DBC03E44718A11785A49FE0608",
  "13909282": "ED0A1D9A20AF445185E7DABB0E20C0A4",
  "13968621": "B621F4611ECC4350928D0082E2B3CC87",
  "13968630": "2D77CE1AE7ED4E2EB2C54E05D0C794CD",
  "13968638": "EEDEBEF1BEC74350A27268BBAD8570C8",
  "13968646": "E6159C4DC0E24B5487D8E804CB689451",
  "13968648": "063636C8A4DD498FBDAC13192CB21983",
  "13968652": "B24B9BCE2BB94B51879CC2E4487294FB",
  "13986895": "91F8A0A9FFC74553A49D1D7CDFC20491",
  "14146283": "F3B6B478A5454FFEB1F7EF416DDD8F17",
  "14915123": "18DB288240C6430D9BF108867AF4BE69",
  "14915129": "BE4A0ECAD75A4529992D914FA68873FA",
  "15219895": "47BB07348A3E4BE6889740259E439449",
  "15219900": "A25BEBD169E34A61A7F5F4093B696C60",
  "15220227": "6E85B11E6A044374B916196933FFF0F7",
  "15222053": "D5119322B2EF4565AAEEA5477FFF3C4F",
  "15229634": "92941C779F164BFFACABEAF873CEAB98",
  "15229636": "28CFBBF37B4E449EB66FE050E16C0DDA",
  "15229648": "D946260522CF4CE6ACF44CA85F86462B",
  "15229655": "E15E1F59D8DE40438F9AD5149D3BC0EB",
  "15604016": "C0BDE3289A854FBAB90B7B480AC4097A",
  "15604024": "34CFE013C7A0431BB2CC8A5025015B55",
  "15604032": "EB79C7D148AB4FB6B959DFB587082AFB",
  "15604040": "BF64556C295F4EB1975FB9CF5CF934F8",
  "15604046": "D3E649C1EC094C6F8A4456D3F06A10B8",
  "15604100": "66D2BF7D508A41C7A479B5164DB4ADAF",
  "15913689": "41E849EAA03049049A730D03EF388364",
  "15913693": "0FF30CF18CA7411C8A2F716AE7693CFA",
  "15913694": "D85D02A3556B41378A18D5218B0A19F0",
  "16005124": "5DDA964874F7471296B8778334746159",
  "16005128": "3C90455A898B480D9F16DCCC45D356AE",
  "16005130": "FF68DF05E2374EFEA269BE1401BE00EE",
  "16005131": "28F5FC9A9E814B9880F7825AE9374787",
  "16005133": "381AE96AB5B046A4853C16AD71D07859",
  "16005135": "7421A2BFADCB4B91B0D9607DAC211F8A",
  "16005136": "CC65416E0A0342EE95002F9F6DC3F744",
  "16005139": "05D425E56C0B44BABD059D4DD6A85D98",
  "16005141": "7BA1B6DD60C64FFE858D4D96EDE1E7EB",
  "16005143": "1F25AC71DECF48358EB2981A8451448B",
  "17689700": "F7A577241F714088BDB4EEF50BC5D457",
  "17689702": "D82D69ABF8084A49B45FD54602902495",
  "17689703": "973E84B73B5F4B87B467D350147D9214",
  "17689706": "9B30F542E43C4581833234567A3DD558",
  "17689707": "C1A3FC2025CD47798935E22A5FEDF04C",
  "17689711": "B318534A2E484ADA8C1715F3C3DB23AD",
  "17689713": "6EAF7A1A88BC489B8F3C90AFDF636A34",
  "17689714": "2C620A1A8DE549938599FB91A4EF469D",
  "17771061": "BC780B2747734F5AB1FE5A50E067D03B",
  "17771069": "1A5246FEDAD14697952D64AC16F5ECE1",
  "20214486": "D92590B50F94480FBA8691092BD460DF",
  "20214584": "1806CE0D3F5F49E98712556841FC6B2E",
  "20214694": "B63C2A548FFC4605B4E5FEED8CDFB96C",
  "20215204": "3786207E43324C37A09B6A32C95F84CA",
  "21288265": "6622F9CBEE834100A894D72B28A750B9",
  "21288268": "376E7B43E84C4193AAEB18568F670924",
  "21288270": "2638AFFDBE574BC0872080DB54888920",
  "21288271": "1C596788C2A444D4B4D92B9043F404A5",
  "21288274": "6621C00D17CB466F82F3D25E40AA70EB",
  "21677260": "DC429736D7374139BA82D8AAC1EBDECD",
  "21677261": "5D7E3B1B859042C998E551DA0CE9965F",
  "21677266": "343A456EF86F43E18014994553DDECA1",
  "21677267": "E27EB9FD39D3436F9B69BE608E553925",
  "21677268": "E1EF6E398D144FBC85860A1245C20C48",
  "21677271": "75395D1FFE6F425BB417025197CC63C7",
  "21677275": "DBBDD314044D4A2388FB0B893F5F80DD",
  "21677276": "E45804AA89C248EDA4DF2279E0D73668",
  "21677277": "D9267F74AC9B4D8A840BFFB0CDE283A5",
  "21677279": "D0941BD2999D4DA5AEEA553161E8778B",
  "23167064": "9D79140C64F94A47B3F99CD28345DE50",
  "23167065": "B5346E55332742C3B84CAFFB4CEE40B7",
  "23167066": "C0D632FAB8774FF8B3086AD2C6838B7A",
  "23167067": "F595B37DF4CA4CDCA296AF5505C7089C",
  "23167071": "F75A9A95A6E543A1B22DA966DA52204C",
  "23167072": "B1E2D8C37F364187847991B77DE6D31E",
  "23167073": "0E20720805B74ABDAB147FCB35210A69",
  "23167075": "C0E5CAAFE8A14F56A68AE2B48F25E7FC",
  "23167091": "36C0CD5D4455429DB09F4B4BD56E9062",
  "27136927": "4B7A319DC1BD4CED85D6FCCBE57858B3",
  "27136931": "C893A767C8CE4CF9BD7DBB803DDFD063",
  "27136932": "CFD19BAEDC1D4A5085BF7ADB59C3CEFF",
  "27136933": "29A961BA43A244539A79D16A35E9C4A5",
  "27136937": "301821DD0C1E46DFA03A86A7B5B5251C",
  "27136938": "146FB6070990466CACF5976F49E19C89",
  "27136939": "B21850618E3B42F18642FE05C4239756",
  "28339890": "C56F94797950490EBB43D26320C2F60C",
  "28339891": "1BE9A586CA0C438CBB49AE63FFCC3973",
  "28339892": "6542A3DC5761486F88CCA45920AFA47D",
  "28339893": "541EDB1B25F7497983D5583C04A5C193",
  "33457144": "ADDD6314B8A94ED39E0BFBC7D03444C4",
  "33457148": "3CFF90D2CCE64BFC9A1A8B456A5D5352",
  "33457171": "27AA1154441F4E55A39EA107D89752CA",
  "34611214": "3C6615BCDC4D4F41B81A6E4E79103927",
  "34611271": "EE7105BBFDF44CB6A6F437E2E4BB8EC5",
  "34611274": "157A44544CF74A87BF98D6F635164898",
  "34611289": "36D44D9FF554402F8F410123A5E1E23F",
  "36276371": "5398756F270F4B5A96BF13A487D9AC39",
  "36276373": "2A515AB6F9C44C7F9A1BB78B4D1E26C2",
  "36276377": "922B75D0AD7E4BA3A985BA023B76A59E",
  "36276379": "9D4392642E2C44C9A3B29EEC1E450F9D",
  "36276380": "B49A1B0B4D034854A324D4C7AE0FC16E",
  "36276381": "95B1FD1C00E545C9913C3A8A4D8E1A44",
  "36276382": "99D657F294314994A26BFF5B839C70D1",
  "36290334": "4B2DD4A260D540938138BCD772910D8F",
  "36290336": "9C1E5E636A2143D38F8BCB88212D1525",
  "36290338": "B1D9E58592B24565A5CB54F69F3C62F4",
  "39569564": "4291DC1A4F8442619C7A003724BDF9E3",
  "39569566": "72D78662E2974329A7F57775450EFADA",
  "39569567": "94E5B3CCE55B4544ADDBA67B4A9B8B26",
  "39569569": "6D7366904C4F4AC8BBB33C1FC1E8E22D",
  "39569572": "50EF96F26E3C4B848FF43492F8288375",
  "39569573": "07D44A0429564DB29CC2E43AAFC7C611",
  "39569575": "A3EF2F681B8B41F6BB41FB2D59740500",
  "39569577": "29B3279F11594DE79B5C19DECFD84E6D",
  "39569714": "FD6B8E9C45174785B30B39B82C6B02D5",
  "42279795": "EB6F596DA6DE4171B8A03611009C4C12",
  "42279796": "4D92FCE63BAB4D67A9AEDD4568519A1B",
  "42279797": "7BA733BA34F941F9A1BDFB941ADF12BF",
  "42279798": "27B9984F44784925B60660C090E5550B",
  "43829461": "66A9B57DBA1C4B309A44FC0ECC1A252D",
  "43829464": "68BB9B4689A146DABF1F432DEB63991E",
  "43829465": "96A6AB9F095D4BA9AE5AC35393B625B5",
  "43829467": "ECB30AC205F94EA099755CFE2268972C",
  "49131178": "84A247A6C0844831A9CEF24E7F48E59A",
  "49131179": "10B774263EBF4D5EAA35DD622284E4DD",
  "49131186": "F68C06F2453A433C867427D5FA38AC68",
  "49131187": "1678D5402B304FE19A08EC9A1AC09476",
  "49131189": "90BCEE8CE0D042F9AA7293000F69D30D",
  "49131190": "A4DE69D485824D6895546DDD28527671",
  "49131191": "8F601FFF318F4855A78784D6F14CA9BE",
  "50162227": "504DF6D83B1E4CD295604FA4E060ECDD",
  "50162228": "C1D947205D824A8CAAE6976866BE11EE",
  "50162230": "7E8440433AE945C599D39585DBFC864B",
  "50162231": "E642F059015B464CAAFD7AB3488BA3D3",
  "50162232": "AF5E5D420642470FAED8D33806DB3013",
  "50162239": "8EFA2169DBDA45AA9C0AD5CD31EB8894",
  "50162240": "72017EE6548A4AFE904617FB1BFE301C",
  "54327723": "232070A2B16544C8986FF29ACD2E1040",
  "54327725": "3A8E6ED36019476A82FC108C27EEC5E2",
  "54327728": "2CE80A59F7564F90B7992AD866CFEBD9",
  "54327729": "AB5584579FB0409792066E8EE95F889F",
  "54327731": "C7CB95D3B5534C05AF172ADB4FE6118B",
  "54327733": "468EC91A4E57470F929B229E917D375A",
  "54327735": "031B16577EAD42C297DC51EBE10DA743",
  "54327739": "D0BB79118AB24BA9BE475AE0A17EB0E3",
  "54327742": "2D0E9E2D54834ED3AD7080EA763E2091",
  "54327744": "428018A4483E4F72AECEF449282F7011",
  "54327745": "5C963D6149FD41619CB246FD738EFB1C",
  "54327746": "8D40392E796C4A14A7C3788B5878A1A3",
  "54327747": "E10B2DABEE1B4E92B86D95D51C09AA9B",
  "54327748": "1C15C65EA1514232B9AD215FD077A779",
  "54327750": "6D75333D792B4C46B6F14F902AA374E2",
  "55125036": "9563A862829D418DB933BD6E1A54157E",
  "55125039": "19952677AFC8421ABD9CDA0AA10D681D",
  "55125040": "2905613FDB004E74BA89E11AEC514CBE",
  "55125042": "2FE8C3B54AF544A483D8E0D4FAEB4A27",
  "55125043": "942B5C500A5B444FBF4CAFF193C686CC",
  "55125045": "0CECCDD66AD3493D9981B15F396E2B0F",
  "55175739": "18AFC06DD3254DD7BD87A5A766A71386",
  "56217091": "83F826803FF14C5899AE7AAD7886DC73",
  "56217093": "B35F2FC932AE47CF9A36214485786E3E",
  "56217095": "5B84B3BCFC1B4D319E41DAF96FDF4265",
  "56217097": "564B9C8AC82C4EC5A53315418BCA2BF9",
  "56217099": "CF49668940AF4FABB3D29EA485CE00B0",
  "56217101": "A9F9DD430F4F4A05B2AA337832765476",
  "56217103": "E032024A0B094BE9916F9E50C072C0BD",
  "56217105": "87D0A2E92FDC42F19AA90B9689A992AE",
  "56240232": "4E5B58E5EFA14644B1E570B56AAD480A",
  "56240234": "BC4442040D50418FA9A71DC47775B90C",
  "56240236": "CFD956CE74554E88BEAFFF6397E13ABC",
  "56240242": "53763F5A82794247BDE8A16F5D040856",
  "56240246": "49FBCB95FF254D84BDDD7FC88B8B0523",
  "56240248": "9415218835424133BFAEE28040C34883",
  "56240252": "AF7178E208B84FAFAD6AE88031C27047",
  "56240254": "D8A599546D5D4E2E9A9A7D81468A0320",
  "56240256": "7DB6E31FFCCD47EFAAEEEF8C90FD8735",
  "56240258": "12B63FC752314E7087141EEF54D76ACB",
  "56240260": "607BFBDDA8A645C2BE0B80FA8A04B64A",
  "56240264": "0157B2CF2CE743D58959492DE03440A9",
  "56240266": "7992CD916997425FB10F246A3DD26995",
  "56240268": "A69A7FC7440C433CB6A8FCF10EC7F535",
  "56240270": "A37D575D1E4F4DF4B7A797ABB474D09E",
  "56240794": "401F291B57C7489D91E8DD0EC352FE7F",
  "56240795": "7F85B15057834DA689015F1B4427E28F",
  "56262138": "14B7DC05EE2E4076A7A2F6C6A9C4D308",
  "56262140": "948CE88830194264BE1ADC3901AEB825",
  "56262142": "3DF69705ADE742A79050DA5BF98FCDCA",
  "56262144": "888BAC7F65DA451D97012042DCD60511",
  "56262146": "577B913B1AAE454B991FD326DC0C0EE6",
  "56262148": "82B2368CC5434C0686AE4D32CF2D7C5F",
  "56262150": "F4441731F07C470096A7A1EF762B0845",
  "56262152": "54D00C4AA1554A149DF6CA96020EC591",
  "56262154": "305F75CFEE854BCA93448CCDD8742D93",
  "56262156": "5F2ADC35FB594F4197C3709B6A4A9112",
  "56262158": "B5F677197DD34F7D86C1CE91CE15F3BA",
  "56262160": "32EC191ADB6D4284B1BCC2E0461D5EFD",
  "56262162": "04180FC0F8254D63815F4368255B2611",
  "56262164": "A7278D66775E49A8A37BDDCD7EEA4C11",
  "354884218": "81000B88C31B436C9BD73CB86894A11E",
  "685006640": "79532FA83E1B40FCAB6AF0C200A47207",
  "679951097": "A58BB0B5BDA74C8F8A9AD6826F940C0B",
  "604295630": "BD0AEBDAE5D049F583C4FFF86C7ED7C7",
  "945315595": "65139D6172BD4D1EB222F9BEEF77D6E2",
  "562363289": "202B4567338C47709B78086CBC92CFFE",
  "858712277": "2DDC5288E4FF41B88B6240EEFC746F25",
  "547276466": "4F25C5E1566F43CFA8C1E8E684800843",
  "112853893": "D7264042390E420CADDB95E104D86E56",
  "253345053": "CC74CA9707A042F89717A3B469ACD6DF",
  "439884728": "4200D545B6114ADF83C64500E29E295C",
  "323053545": "4E8FC7E03392441ABF3B48E85ADCC859",
  "845997025": "8C0855435AF44CBBA01578D6C7C42CF4",
};

const offerIdParam = getQueryParameterByName('offerID');
const walmartId = getQueryParameterByName('walmartID');
const offerId = offerIdLookupHackJob[walmartId] ? offerIdLookupHackJob[walmartId] : offerIdParam;
const productUrl = getQueryParameterByName('productURL');

const WalmartLoader = {
  addToCartUrl: false,
  productId: _.get(location.pathname.match(/\/p\/([0-9]+)/), 1),
  configId: _.get(location.pathname.match(/\/c\/([0-9]+)/), 1),
  offerId,
  walmartId,
  redirectUrl: getQueryParameterByName('redirectURL'),
  productUrl
};

export default WalmartLoader;



// WEBPACK FOOTER //
// ./src/base/scripts/loaders/walmart.js